import { createSelector } from "reselect";

import { getOperatorProfileRatings } from "./state-accessors";

export const getOperatorProfileRatingById = createSelector(
  [getOperatorProfileRatings, (_: unknown, profile_id: number) => profile_id],
  (profile_ratings, profile_id) => {
    return profile_ratings[profile_id];
  }
);
